// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__kgdxo","empty":"ModalGraph_empty__1gskX"};